<!-- <div id="main" style="width: 100%; height: 150px"></div> -->
<!-- <div echarts [options]="options" class="demo-charts"></div> -->
<div
  echarts
  class="echarts mt-1"
  [options]="option"
  style="height: 200px; width: 100%"
></div>
